import { getCurrentLocale } from './localization.ts';
import { trackEvent } from './analytics.ts';

function initLangSwitch(): void {
  const langSwitch = document.getElementById('langSwitch');
  if (!langSwitch) return;

  const locale = getCurrentLocale();
  if (locale !== 'et') {
    langSwitch.hidden = true;
    langSwitch.style.display = 'none';
    return;
  }

  langSwitch.hidden = false;
  langSwitch.style.display = '';

  const targetUrl = langSwitch.dataset.targetUrl || 'https://gadgettamer.com';
  langSwitch.addEventListener('click', () => {
    trackEvent('ui:language_change', {
      from_lang: locale,
      to_lang: 'en',
    });
    window.location.href = targetUrl;
  });
}

export { initLangSwitch };
